import React from 'react';
import PropTypes from 'prop-types';
import { get, has } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { Image } from '@bd/bdcore-utilities';
import { colors } from '../styles';

const styles = css`
  width: 100%;
  margin: 0 0 30px 0;
  border: 1px solid #eee;
  .PlanCard_wrapper {
    display: flex;
  }
  .PlanCard_inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
  }
  .PlanCard_media {
    img {
      width: 100%;
      height: auto;
    }
  }
  .PlanCard_content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    background-color: #F5F5F5;
    padding: 30px 20px 0 20px;
    h4 a {
      color: ${colors.color5};
      font-weight: 700;
      font-size: 24px;
      line-height: 24px;
      margin: 0;
      display: block;
    }
    h5 a {
      font-weight: 300;
      font-size: 18px;
      line-height: 18px;
      color: ${colors.color5};
      margin: 0;
      display: block;
    }
    .PlanCard_priceWrapper {
      border-top: 1px solid ${colors.color3};
      border-bottom: 1px solid ${colors.color3};
      display: flex;
      width: 45%;
      background-color: ${colors.color3Light};
      align-items: center;
      justify-content: center;
      .PlanCard_priceValue {
        font-size: 19px;
        font-weight: 300;
        margin: 0;
      }
    }
    .PlanCard_textList {
      list-style: none;
      padding: 10px 0;
      margin: 0;
      border-bottom: 1px solid #CCCCCC;
      border-top: 1px solid #CCCCCC;
      flex-grow: 1;
      position: relative;
      .PlanCard_textListItem {
        font-size: 14px;
        font-weight: 400;
        width: 100%;
      }
    }
    .PlanCard_listHeader {
      font-size: 13px;
      font-weight: 300;
      line-height: 1;
      border-top: 1px solid ${colors.color3};
      padding: 10px;
      display: block;
      color: ${colors.color5};
      &-submenu {
        background-image: url('/images/icon-triangle-gold.svg');
        background-position: 95% center;
        background-repeat: no-repeat;
      }
    }
    .PlanCard_iconList {
      display: flex;
      list-style: none;
      margin: 0 0 15px 0;
      padding: 0;
      li {
        border-right: 1px solid #CCCCCC;
        width: 25%;
        text-align: center;
        padding: 12px 0;
        font-size: 14px;
        font-weight: 300;
        line-height: 18px;
        span {
          display: block;
        }
        &:last-child {
          border: 0;
        }
        .PlanCard_iconListIcon {
          margin: 0 0 4px 0;
        }
        .PlanCard_iconListValue {
          font-weight: 700;
        }
        a {
          color: ${colors.color3};
          font-weight: 700;
        }
        .PlanCard_linkIcon {
          width: 13px;
          height: 13px;
          margin: 5px 0 0 0;
        }
      }
    }
    .PlanCard_buttonWrapper {
      display: flex;
      justify-content: flex-end;
      margin: 0;
      .PlanCard_mapButton {
        width: 40px;
        height: 40px;
        background-color: #6C6C6C;
        background-image: url('/images/icon-map-pin-white.svg');
        background-position: center center;
        background-repeat: no-repeat;
      }
      .PlanCard_detailButton {
        flex-grow: 1;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: ${colors.color2};
        color: #FFFFFF;
        font-weight: 700;
        font-size: 15px;
      }
    }
  }
`;

class PlanCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showMenu: false,
    };

    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setToggleRef = this.setToggleRef.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  setToggleRef(node) {
    if (this.toggleRef) {
      this.toggleRef.removeEventListener('click', this.handleToggle);
    }

    this.toggleRef = node;
    if (this.toggleRef) {
      this.toggleRef.addEventListener('click', this.handleToggle);
    }
  }

  handleToggle(event) {
    event.preventDefault();

    this.setState({
      showMenu: !this.state.showMenu,
    });
  }

  handleClickOutside(event) {
    if (
      this.toggleRef
      && !this.toggleRef.isSameNode(event.target)
      && !this.toggleRef.contains(event.target)
      && this.state.showMenu
    ) {
      this.setState({
        showMenu: false,
      });
    }
  }

  render() {
    const { plan, page } = this.props;

    const background = {};
    if (has(plan, 'photos[1].contentUrl')) {
      background.backgroundImage = get(plan, 'photos[1].contentUrl');
    } else if (has(plan, 'photos[0].contentUrl')) {
      background.backgroundImage = get(plan, 'photos[0].contentUrl');
    } else {
      background.backgroundImage = get(page, 'default_card_image.contentUrl');
    }

    return (
      <div className={styles}>
        <div className="PlanCard_wrapper">
          <div className="PlanCard_inner">
            <div className="PlanCard_media">
              <Link name="plan-detail" plan={plan}>
                <Image
                  src={background.backgroundImage}
                  alt={get(plan, 'name')}
                  width={600}
                  height={337}
                  exact
                />
              </Link>
            </div>
            <div className="PlanCard_content">
              <h4>
                <Link name="plan-detail" plan={plan}>
                  {get(plan, 'name')}
                </Link>
              </h4>
              {
                (get(plan, 'builder_name') || get(plan, 'plan_type')) &&
                <ul className="PlanCard_textList">
                  {get(plan, 'builder_name') && <li className="PlanCard_textListItem"><strong>Builder: </strong>{get(plan, 'builder_name')}</li>}
                  {get(plan, 'plan_type') && <li className="PlanCard_textListItem"><strong>Plan Type: </strong>{get(plan, 'plan_type')}</li>}
                </ul>
              }
              <ul className="PlanCard_iconList">
                {
                  get(plan, 'bedroom_range') &&
                  <li>
                    <span className="PlanCard_iconListIcon"><img src="/images/icon-beds.svg" alt="" /></span>
                    <span className="PlanCard_iconListValue">{get(plan, 'bedroom_range')}</span>
                    <span className="PlanCard_iconListLabel">Beds</span>
                  </li>
                }
                {
                  !get(plan, 'bedroom_range') &&
                  <li>
                    <span className="PlanCard_iconListIcon"><img src="/images/icon-beds.svg" alt="" /></span>
                    <span className="PlanCard_iconListValue">{get(plan, 'beds')}</span>
                    <span className="PlanCard_iconListLabel">Beds</span>
                  </li>
                }
                {
                  get(plan, 'bathsFull') &&
                  <li>
                    <span className="PlanCard_iconListIcon"><img src="/images/icon-baths.svg" alt="" /></span>
                    <span className="PlanCard_iconListValue">
                      {get(plan, 'bathsFull')} {get(plan, 'bathsHalf', 0) > 0 && '.5'}
                    </span>
                    <span className="PlanCard_iconListLabel">Baths</span>
                  </li>
                }
                {
                  get(plan, 'sqft') &&
                  <li>
                    <span className="PlanCard_iconListIcon"><img src="/images/icon-sqft.svg" alt="" /></span>
                    <span className="PlanCard_iconListValue">{numeral(get(plan, 'sqft')).format('0,0')}</span>
                    <span className="PlanCard_iconListLabel">SQ FT</span>
                  </li>
                }
                <li>
                  <Link name="plan-detail" plan={plan}>
                  View<br />Details<br />
                    <img src="/images/icon-arrow-right.svg" className="PlanCard_linkIcon" alt="" />
                  </Link>
                </li>
              </ul>
              {/* <div className="PlanCard_buttonWrapper">
              <Link className="PlanCard_mapButton" />
              <Link className="PlanCard_detailButton">Visit Community</Link>
            </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PlanCard.propTypes = {
  plan: PropTypes.object.isRequired,
  page: PropTypes.object,
};

PlanCard.defaultProps = {
  communities: [],
  homes: [],
  page: undefined,
};

export default withData({
  plan: true,
  communities: true,
  homes: true,
  page: 'plans',
})(PlanCard);



// WEBPACK FOOTER //
// ./src/components/PlanCard.js